import { Image, Tooltip } from '@chakra-ui/react';
import Platforms, { PlatformEnums } from '../../../../utils/platforms';
import { platformLogo } from 'utils/utils';
import { useSelector } from 'react-redux';

const PlatformCellRenderer = ({ value }) => {
    const { currentCompanyPlatforms } = useSelector(
        (state) => state.navigationLists,
    );

    const platformDefined = () => {
        const platform = currentCompanyPlatforms?.find(
            (platform) => platform.id === value,
        );
        return platform;
    };

    const platformLocal = () => {
        return Platforms[value];
    };

    const isEightByEight =
        platformDefined()?.name === '8x8' || platformLocal()?.name === '8x8';

    const isOperatorPlatform =
        platformDefined()?.id === PlatformEnums.OPERATOR_PLATFORM;

    const isDialPad = platformDefined()?.id === PlatformEnums.DIALPAD;

    // (3022) Both GCC High platforms share the square flag logo, which reads as
    // a hard-edged tile beside the round ones. Matched on `value` rather than
    // `platformDefined()` because the resource account platform is a local
    // pseudo-platform and never appears in the company's platform list.
    const isGCCHigh =
        value === PlatformEnums.GCC || value === 'ms_resource_account_gcch';

    const isRounded =
        isEightByEight || isOperatorPlatform || isDialPad || isGCCHigh
            ? 'rounded-full'
            : '';

    // NOTE: (3117)
    if (!value || (!platformDefined() && !platformLocal())) return null;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
            }}>
            <Tooltip
                label={platformLocal()?.name || platformDefined()?.name}
                placement="bottom"
                hasArrow>
                <Image
                    src={platformLogo(
                        platformDefined()?.logo,
                        platformLocal()?.icon,
                    )}
                    boxSize="7"
                    className={isRounded}
                />
            </Tooltip>
        </div>
    );
};

export default PlatformCellRenderer;
